import { getEnv, handleErrorV2 } from 'components/AE/utils/FetchUtils';
import { toastr } from 'react-redux-toastr';
import { CA_PRODUCT_CODES, EMAIL_REGEXP, USER_TYPES } from '../constants/AppConstants';
import loggerObj from './Logger';

export const getDomainName = () => {
    return {
        domain: `${process.env.REACT_APP_NEW_HOST}`,
        oldDomain: `${process.env.REACT_APP_HOST}`,
        mp: `${process.env.REACT_APP_MP_HOST}`,
        cra: `${process.env.REACT_APP_CS_HOST}`,
        login: `${process.env.REACT_APP_LOGIN_URI}`,
        otp: `${process.env.REACT_APP_OTP_URI}`,
    };
};

export const triggerDownload = (blob: Blob, filename: string) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout((_) => {
        window.URL.revokeObjectURL(url);
    }, 60000);
    a.remove();
};

const downloadFile = (url: string, filename: string) => {
    fetch(url, { method: 'GET' })
        .then((res: any) => {
            return res.blob();
        })
        .then((blob: Blob) => {
            triggerDownload(blob, filename);
        })
        .catch((err) => {
            loggerObj.logException(new Error(err));
            handleErrorV2(err, 'Error in downloading file').then(
                ({ message, title, toastType = 'error' }: any) => {
                    const { [toastType]: toast }: any = toastr;
                    toast(title, message);
                }
            );
        });
};

export const handleFileLink = (url: string, name: string, canDownload = false) => {
    try {
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        if (canDownload) {
            return downloadFile(url, name);
        } else {
            a.download = name;
            a.target = '_blank';
        }
        if (document.body) {
            document.body.appendChild(a);
            a.click();
            a.remove();
        }
    } catch (e) {
        console.error(e);
    }
};

export const fetchUserGroup = (groupId: string, productId: string) => {
    let userGroup = groupId;
    if (productId === CA_PRODUCT_CODES.BILL_DISCOUNTING) {
        userGroup = groupId === USER_TYPES.CUSTOMER ? USER_TYPES.ANCHOR : groupId;
    }
    return userGroup;
};

export const validateEmail = (email: string) => {
    if (EMAIL_REGEXP.test(email)) return true;
    return false;
};

export const nextUrlCheck = (url: string) => {
    try {
        const domain = new URL(url);
        if (
            domain?.hostname?.includes(process.env.REACT_APP_HOST ?? '') ||
            domain?.hostname?.includes(process.env.REACT_APP_NEW_HOST ?? '')
        )
            return url;
        return getEnv(process.env.REACT_APP_CS_HOST ?? '');
    } catch (e) {
        return getEnv(process.env.REACT_APP_CS_HOST ?? '');
    }
};

export const parseDomain = () => {
    const [subDomain, domain, type] = window.location.host?.split('.');
    return { subDomain, domain, type };
};

export const getCurrentDomain = () => {
    const { domain } = parseDomain();
    return domain;
};

export function getValueForKeyContainingSubstring(obj: any, substring: string) {
    for (const key in obj) {
        if (key.includes(substring)) {
            return obj[key];
        }
    }
    return null; // Return null if no key contains the substring
}

export const getCountryCode = () => {
    return process.env.REACT_APP_COUNTRY_CODE || 'IN';
};

export const validateMobileNumber = (
    mobileNumber: string,
    countryCode: string = getCountryCode()
) => {
    // Remove any non-digit characters from the mobile number
    const cleanedNumber = mobileNumber.replace(/\D/g, '');

    // Validation rules based on country code
    if (countryCode?.toLowerCase() === 'in') {
        // India - must be exactly 10 digits
        return cleanedNumber.length === 10 && /^[6-9]\d{9}$/gi.test(cleanedNumber);
    } else if (countryCode?.toLowerCase() === 'ae') {
        // UAE - must be 9 digits and start with 5
        return cleanedNumber.length === 9 && /^5\d{8}$/.test(cleanedNumber);
    }

    // For other country codes, return false or implement additional validation rules
    return false;
};

export const getCountryPropsByCode = (countryCode: string = getCountryCode()) => {
    switch (countryCode) {
        case 'AE':
            return {
                countryCode: 'AE',
                mobileCountryCode: '+971',
            };
        default:
            return {
                countryCode: 'IN',
                mobileCountryCode: '+91',
            };
    }
};
